<template>
  <div
    v-if="datapoint"
    class="rbu-item-module-data-point rbu-item-module-table-row no-border"
  >
    <div class="ignored-overlay" v-if="datapoint.ignored"></div>
    <div class="rbu-item-module-row-column-1"></div>
    <div class="rbu-item-module-row-column-2">
      <RbuPeriodInput
        outlined
        dense
        hide-details
        disabled
        :value="datapoint.period"
        @input="onPeriodUpdate"
      ></RbuPeriodInput>
      <RbuDatapointInput
        dataset-type="RBU"
        :period="datapoint.period"
        :value="datapoint.datapoint"
        @input="onDatapointUpdate"
      ></RbuDatapointInput>
    </div>
    <div class="rbu-item-module-row-column-3">{{ idx + 1 }}</div>
    <div class="rbu-item-module-row-column-value">
      <div class="pa-2">{{ $parseCurrency(afterFormula) }}</div>
    </div>
    <div class="rbu-item-module-row-column-multiplier"></div>
    <div class="rbu-item-module-row-column-formula">
      <div
        class="rbu-item-module-row-column-formula-wrapper"
        style="flex-direction: column"
      >
        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 0.5rem;
            width: 100%;
          "
        >
          <v-textarea
            outlined
            auto-grow
            rows="1"
            dense
            hide-details
            :value="formulaPrefix"
            @input="onFormulaUpdate($event, formulaSuffix)"
          ></v-textarea>

          <div class="rbu-item-module-row-column-formula-rate">
            Rate<br />{{
              datapoint.datapoint
                ? `(${$parseCurrency(datapoint.datapoint.value)})`
                : ""
            }}
          </div>

          <v-textarea
            outlined
            dense
            hide-details
            auto-grow
            rows="1"
            :value="formulaSuffix"
            @input="onFormulaUpdate(formulaPrefix, $event)"
          ></v-textarea>
        </div>
        <!-- <span v-if="parsedFormula">Full Formula: {{ parsedFormula }}</span> -->
      </div>
    </div>
    <div class="rbu-item-module-row-column-descriptions">
      <v-textarea
        outlined
        auto-grow
        rows="1"
        dense
        hide-details
        placeholder="Description"
        :value="datapoint.descriptions"
        @input="onUpdate({ descriptions: $event })"
      ></v-textarea>
    </div>
    <div
      class="rbu-item-module-row-column-actions"
      style="
        display: flex;
        flex-direction: row;
        align-items: top;
        justify-content: start;
      "
    >
      <v-btn
        icon
        color="primary"
        @click="$refs.fileInput.click()"
        v-if="!datapoint.file"
      >
        <v-icon>mdi-upload</v-icon>
      </v-btn>
      <span v-else>
        <span
          class="rbu-item-module-datapoint-file"
          @click="showFile(datapoint.file)"
          >{{
            datapoint.file instanceof File
              ? datapoint.file.name
              : datapoint.file.filename
          }}</span
        >
        <v-btn icon small color="primary" @click="onUpdate({ file: null })">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </span>
      <input type="file" hidden ref="fileInput" @change="onFileInputChange" />

      <v-btn icon color="primary" @click="$emit('delete')">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <v-checkbox
        dense
        hide-details
        class="ignore-checkbox ml-4"
        style="padding-top: 0"
        :input-value="datapoint.ignored"
        @change="onUpdate({ ignored: $event })"
      >
        <template #label>
          <span
            style="
              font-family: Roboto, sans-serif;
              font-size: 14px;
              font-weight: 500;
              font-stretch: 100%;
              letter-spacing: 1.25px;
              line-height: normal;
              text-indent: 1.25px;
            "
            >IGNORE</span
          >
        </template>
      </v-checkbox>
    </div>
  </div>
</template>
<script>
import RbuDatapointInput from "@/components/rbu/RbuDatapointInput.vue";
import RbuPeriodInput from "@/components/rbu/RbuPeriodInput.vue";
import { computed, inject, ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import floatingPointFix from "js-floating-point";

export default {
  name: "RbuItemModuleDataPoint",
  props: {
    datapoint: Object,
    idx: Number,
  },
  components: { RbuPeriodInput, RbuDatapointInput },
  setup(props, { root, emit }) {
    const item = inject("RBU_ITEM");
    const latest = inject("RBU_EDITION_LATEST");
    const base_start = inject("RBU_EDITION_BASE_START");
    const base_end = inject("RBU_EDITION_BASE_END");

    const onPeriodUpdate = async function (period) {
      let d = { period };

      let newPeriod =
        {
          LATEST: latest.value,
          BASE_START: base_start.value,
          BASE_END: base_end.value,
        }[period] || period;
      if (
        newPeriod &&
        props.datapoint.datapoint &&
        props.datapoint.datapoint.period !== newPeriod
      ) {
        // Try getting the new datapoint
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/datapoint/",
          params: {
            filters: {
              period: [newPeriod],
              dataset: [props.datapoint.datapoint.dataset.id],
              type: [props.datapoint.datapoint.type],
            },
            page_size: -1,
          },
        });

        if (response.body.success && response.body.points.length === 1) {
          d.datapoint = response.body.points[0];
        } else {
          d.datapoint = null;
        }
      }

      onUpdate(d);
    };

    const onDatapointUpdate = function (datapoint) {
      console.debug("onDatapointUpdate", datapoint);
      let d = { datapoint };

      if (datapoint.period) {
        let originalPeriod =
          {
            LATEST: latest.value,
            BASE_START: base_start.value,
            BASE_END: base_end.value,
          }[props.datapoint.period] || props.datapoint.period;

        if (datapoint.period !== originalPeriod) {
          d["period"] = datapoint.period;
        }
      }

      onUpdate(d);
    };

    const onUpdate = async function (d) {
      console.debug("onUpdate", d);

      emit("input", {
        ...props.datapoint,
        ...d,
      });
    };

    const fileInput = ref();
    const onFileInputChange = async function (e) {
      const file = e.target.files[0];
      const FILE_SIZE_LIMITED = 2 * 1024 * 1024;
      if (file.size > FILE_SIZE_LIMITED) {
        e.target.value = "";
        alert("The file size must not exceed 2MB.");
      } else {
        fileInput.value.value = "";
        if (file) {
          onUpdate({
            file,
          });
        }
      }
    };
    const showFile = function (file) {
      if (file instanceof File) {
        const url = URL.createObjectURL(file);
        window.open(url, "_blank");
      } else {
        root.$downloadFile(file.id);
      }
    };

    const formulaPrefix = computed(() => {
      const components = (props.datapoint.formula || "").split("{{VALUE}}");

      if (components.length === 2) {
        return components[0];
      }
      return "";
    });
    const formulaSuffix = computed(() => {
      const components = (props.datapoint.formula || "").split("{{VALUE}}");

      if (components.length === 2) {
        return components[1];
      }
      return "";
    });
    const parsedFormula = computed(() => {
      if (props.datapoint.datapoint) {
        return (props.datapoint.formula || "{{VALUE}}").replace(
          "{{VALUE}}",
          props.datapoint.datapoint.value
        );
      }
      return "";
    });
    const onFormulaUpdate = function (prefix, suffix) {
      onUpdate({ formula: `${prefix}{{VALUE}}${suffix}` });
    };
    const afterFormula = computed(() => {
      let formula = props.datapoint.formula || "{{VALUE}}";
      if (formula && props.datapoint.datapoint) {
        try {
          formula = formula.replace(
            "{{VALUE}}",
            props.datapoint.datapoint.value
          );
          return floatingPointFix(eval(formula));
        } catch (e) {
          console.log(e);
          return props.datapoint.datapoint.value;
        }
      }

      return 0;
    });

    return {
      item,
      onPeriodUpdate,
      onDatapointUpdate,
      onUpdate,
      fileInput,
      onFileInputChange,
      showFile,
      formulaPrefix,
      formulaSuffix,
      parsedFormula,
      onFormulaUpdate,
      afterFormula,
      File,
    };
  },
};
</script>

<style lang="less">
.rbu-item-module-data-point {
  display: contents;
  position: relative;

  .ignored-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .rbu-item-module-row-column-2 {
    display: flex;
    gap: 8px;
  }

  .rbu-item-module-row-column-formula-wrapper {
    display: flex;
    gap: 10px;
    align-items: center;

    .rbu-item-module-row-column-formula-rate {
      background-color: rgba(167, 18, 23, 1);
      color: white;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0.15px;
      text-align: left;

      padding: 4px;
      gap: 10px;
      border-radius: 8px;
    }
  }

  .rbu-item-module-datapoint-file {
    // font-size: 80%;
    font-size: 100%;
    word-break: break-all;
    text-decoration: underline;
    color: var(--v-primary-base);
    cursor: pointer;
    max-width: 100px;
    overflow: hidden;
  }
}
</style>
